import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';
import logo from '../Assets/logo.png';
import '../App.css';
import Image from 'react-bootstrap/Image';

function NavbarExport() {
    return (
        <Navbar collapseOnSelect expand="lg" bg="light" variant="light"  fixed={'top'}
        className={'position-sticky ps-0'}>
            <Container>
                <Navbar.Brand href="/">
                    <Image src={logo} style={{ height: "100px" }} />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">
                    </Nav>
                    <Nav>
                        <Nav.Link>
                            <Link to="/"   style={{ color:"#6883BC",textDecoration: "none",fontSize: "18px" }} >Home</Link>
                        </Nav.Link>
                        <Nav.Link>
                            <Link to="/about" style={{ color:"#6883BC",textDecoration: "none",fontSize: "18px" }}>About</Link>
                        </Nav.Link>
                        <Nav.Link>
                            <Link to="/services" style={{  color:"#6883BC",textDecoration: "none",fontSize: "18px" }}>Services</Link>
                        </Nav.Link>
                        <Nav.Link>
                            <Link to="/contact" style={{  color:"#6883BC",textDecoration: "none",fontSize: "18px" }}>Contact</Link>
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavbarExport;